import CurrentUserDetailsActionConstants from "./userDetails/CurrentUserDetailsActionsConstants.js";
const updateCurrentUserMetadata = (id) => {
  return {
    type: CurrentUserDetailsActionConstants.UPDATE_CURRENT_USER_METADATA,
    payload: {
      id
    }
  };
};
const updatedCurrentUserMetadata = (userDetails) => {
  return {
    type: CurrentUserDetailsActionConstants.UPDATED_CURRENT_USER_METADATA,
    payload: {
      userDetails
    }
  };
};
const loadUserAffinity = () => {
  return {
    type: CurrentUserDetailsActionConstants.LOAD_USER_AFFINITY
  };
};
const loadingUserAffinity = () => {
  return {
    type: CurrentUserDetailsActionConstants.LOADING_USER_AFFINITY
  };
};
const loadedUserAffinity = (workspaceId, managementGroup) => {
  return {
    type: CurrentUserDetailsActionConstants.LOADED_USER_AFFINITY,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadExperimentationGroup = (workspaceId, managementGroup) => {
  return {
    type: CurrentUserDetailsActionConstants.LOAD_EXPERIMENTATION_GROUP,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadingExperimentationGroup = (workspaceId, managementGroup) => {
  return {
    type: CurrentUserDetailsActionConstants.LOADING_EXPERIMENTATION_GROUP,
    payload: {
      workspaceId,
      managementGroup
    }
  };
};
const loadedExperimentationGroup = (workspaceId, managementGroup, experimentationGroup, error) => {
  return {
    type: CurrentUserDetailsActionConstants.LOADED_EXPERIMENTATION_GROUP,
    payload: {
      workspaceId,
      managementGroup,
      experimentationGroup,
      error
    }
  };
};
const CurrentUserDetailsActions = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  loadExperimentationGroup,
  loadUserAffinity,
  loadedExperimentationGroup,
  loadedUserAffinity,
  loadingExperimentationGroup,
  loadingUserAffinity,
  updateCurrentUserMetadata,
  updatedCurrentUserMetadata
}, Symbol.toStringTag, { value: "Module" }));
export {
  CurrentUserDetailsActions as C,
  loadExperimentationGroup as a,
  loadingUserAffinity as b,
  loadedExperimentationGroup as c,
  loadingExperimentationGroup as d,
  loadUserAffinity as e,
  updateCurrentUserMetadata as f,
  loadedUserAffinity as l,
  updatedCurrentUserMetadata as u
};
//# sourceMappingURL=CurrentUserDetailsActions-e58069ba.js.map
